<template lang="pug">
.c-the-home-activity
  .title 活動花絮
  div(v-if="article"
    :class="$style.content")
    div(:class="$style.left")
      figure(:class="$style.cover")
        img(:src="cover")
    div(:class="$style.right")
      router-link(:class="$style.articleTitle"
        :to="toArticleDeclar")
        .subtitle.app-text {{ article.title || "" }}
      .content
        p(:class="$style.articleContent") {{ content }}
      thumb-row(:class="$style.row"
        :thumbs="thumbs"
        @select:thumb="selectThumb($event)")
      b-button(:class="$style.more"
        :to="{ name: 'activity' }"
        type="is-info"
        tag="router-link") 更多活動花絮
  b-modal(:class="$style.modal"
    :active.sync="reader"
    custom-class="modal")
    gallery-reader(:items="article ? article.photos : []"
      :current.sync="current"
      @select:thumb="selectThumb($event)")
</template>

<script>
import BaseUrlProvider from "@/components/BaseUrlProvider.vue";
import BaseThumb from "@/components/BaseThumb.vue";
import ThumbRow from "@/components/ThumbRow.vue";
import GalleryReader from "@/components/GalleryReader.vue";

export default {
  name: "TheHomeActivity",
  components: {
    BaseUrlProvider,
    BaseThumb,
    ThumbRow,
    GalleryReader
  },
  props: {
    article: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      current: null,
      reader: false
    };
  },
  computed: {
    cover() {
      return !this.article
        ? ""
        : this.article.cover
        ? this.article.cover.src
        : "";
    },
    thumbs() {
      return this.$u
        .get(this.article, "photos", [])
        .slice(0, 10)
        .map(photo => photo.src);
    },
    content() {
      if (!this.article) return;
      const html = this.article.content;
      return html.replace(/<[^>]*>/g, " ");
    },
    toArticleDeclar() {
      return {
        name: "article",
        params: {
          type: "activity",
          id: this.article ? this.article.temp.id : ""
        }
      };
    }
  },
  methods: {
    selectThumb(index) {
      this.reader = true;
      this.current = index;
    }
  }
};
</script>

<style module lang="sass">
.content
  +flexbox(flex-start, stretch)
  +wrap
  position: relative

.left
  flex: 5 0
  min-width: 100%
  +tablet
    min-width: 448px

.right
  +flexbox(flex-start, stretch, column)
  flex: 7 0
  min-width: 100%
  +tablet
    min-width: 320px
    padding-left: pxRem(24)

.cover
  +ratioImage(3, 2)

.articleTitle
  margin: pxRem(18) 0
  +tablet
    margin: 0

.articleContent
  +ellipsis
  padding: pxRem(6) 0

.rowWrap
  position: relative
  width: 100%

.row
  margin-top: auto
  max-width: 100%

.more
  margin: pxRem(18) 0

.modal :global(.modal-content)
  max-height: none
  overflow: hidden
</style>
